import Vue from 'vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend, configure } from 'vee-validate'
import { required, email, ext, max } from 'vee-validate/dist/rules'

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

export function configureValidationRules() {
  extend('required', {
    ...required,
    message: 'This field is required'
  })

  extend('email', {
    ...email
  })

  extend('maxLength', {
    validate: (value, length) => {
      return value.length <= length
    },
    message: 'This field is too long'
  })
  extend('max', { ...max, message: 'This field is too long' })
  extend('ext', { ...ext, message: 'File is not of a valid type' })

  extend('not_in_past', {
    validate: (value) => {
      return value >= new Date()
    },
    message: 'Date must be in the future'
  })

  configure({
    classes: {
      valid: 'is-valid',
      invalid: 'is-danger',
      dirty: 'is-dirty'
    }
  })
}

configureValidationRules()
